import "./styles.scss";
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import useOrganizationSettings, {
  getPatientWord,
} from "utils/hooks/organizations/useOrganizationSettings";

const EmptyTableBody = ({ dataType }) => {
  const { t } = useTranslation(["common"]);
  const { settings: orgSettings } = useOrganizationSettings();

  const getEmptyStateText = () => {
    if (dataType === "patient") {
      return t("patients.empty_patient_search", {
        patientWord: getPatientWord(orgSettings),
      });
    }

    if (dataType) {
      return `Add a ${dataType} to get started`;
    }

    return "You do not have any data yet.";
  };

  return (
    <tbody>
      <tr>
        <td className="empty-state-data-cell">
          <span>{getEmptyStateText()}</span>
        </td>
      </tr>
    </tbody>
  );
};

EmptyTableBody.propTypes = {
  text: PropTypes.string,
};

export default EmptyTableBody;
